var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('StockBalance')],1),_c('v-flex',{attrs:{"d-flex":"","xs12":"","md8":""}},[_c('MissingSerialNumber')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }